import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  cancelled: {
    defaultMessage: 'Cancelled',
    description: 'Cancelled badge message',
    id: 'frontend-app-ora.XBlockView.StatusRow.cancelled',
  },
  notReady: {
    defaultMessage: 'Not ready yet',
    description: 'Not ready yet badge message',
    id: 'frontend-app-ora.XBlockView.StatusRow.notReady',
  },
  waiting: {
    defaultMessage: 'Waiting',
    description: 'Waiting badge message',
    id: 'frontend-app-ora.XBlockView.StatusRow.waiting',
  },
  notAvailable: {
    defaultMessage: 'Not available yet',
    description: 'Not available yet badge message',
    id: 'frontend-app-ora.XBlockView.StatusRow.notAvailable',
  },
  pastDue: {
    defaultMessage: 'Past due',
    description: 'Past-due badge message',
    id: 'frontend-app-ora.XBlockView.StatusRow.pastDue',
  },
  closed: {
    defaultMessage: 'Closed',
    description: 'Closed badge message',
    id: 'frontend-app-ora.XBlockView.StatusRow.closed',
  },
  teamRequired: {
    defaultMessage: 'Team required',
    description: 'Team-required badge message',
    id: 'frontend-app-ora.XBlockView.StatusRow.teamRequired',
  },
  inProgress: {
    defaultMessage: 'In progress',
    description: 'In-progress badge message',
    id: 'frontend-app-ora.XBlockView.StatusRow.inProgress',
  },
  submitted: {
    defaultMessage: 'Response submitted',
    description: 'Response submitted badge message',
    id: 'frontend-app-ora.XBlockView.StatusRow.submitted',
  },
  practiceCompleted: {
    defaultMessage: 'Practice grading is completed',
    description: 'Practice grading complete badge message',
    id: 'frontend-app-ora.XBlockView.StatusRow.practiceCompleted',
  },
  selfCompleted: {
    defaultMessage: 'Self assessment is completed',
    description: 'Self assessment complete badge message',
    id: 'frontend-app-ora.XBlockView.StatusRow.selfCompleted',
  },
  peerCompleted: {
    defaultMessage: 'Peer assessment is completed',
    description: 'Peer assessment complete badge message',
    id: 'frontend-app-ora.XBlockView.StatusRow.peerCompleted',
  },
  complete: {
    defaultMessage: 'Complete',
    description: 'Complete badge message',
    id: 'frontend-app-ora.XBlockView.StatusRow.complete',
  },
});

export default messages;
